import { apiClient } from './api-client';
import { ApiResponse, ReportData } from '../types';

export const ReportService = {
  /**
   * Get report data showing grade, subject, chapter, notes, and questions counts
   * @returns Promise that resolves to an array of ReportData objects
   */
  async getReportData(): Promise<ReportData[]> {
    const response = await apiClient.get('/report');
    
    // Handle the actual API response structure: data.report
    if (response.data && response.data.data && response.data.data.report && Array.isArray(response.data.data.report)) {
      return response.data.data.report;
    }
    
    return [];
  }
};